module.exports = __webpack_public_path__ + "static/media/bbraun-logo.c5e3fa52.svg";